import { Component, Prop, State, Event as StencilEvent, EventEmitter, Watch, h } from '@stencil/core';

@Component({
  tag: 'search-box',
  styleUrl: 'search-box.css',
  shadow: true,
})
export class SearchBox {
  /**
   * An array of search result strings
   */
  @Prop() searchResults: string[] = [];
  @State() highlightedResults: string[] = [];
  @State() showResults: boolean = false;
  @State() inputValue: string = '';

  @Watch('searchResults')
  watchSearchResults(newValue: string[]) {
    this.highlightedResults = newValue.map(result => {
      return result.replace(new RegExp(this.inputValue, 'gi'), match => `<b><mark>${match}</mark></b>`);
    });
    console.log(this.highlightedResults);
  }
  @Watch('inputValue')
  handleInputValue(newValue: string) {
    this.searchInputChanged.emit(newValue);
  }

  /**
   * Search input changed event
   */
  @StencilEvent({
    bubbles: true,
    cancelable: true,
    composed: true,
  })
  searchInputChanged: EventEmitter<string>;
  /**
   * Search result list item selected event
   */
  @StencilEvent({
    bubbles: true,
    cancelable: true,
    composed: true,
  })
  searchResultSelected: EventEmitter<number>;
  /**
   * Search button clicked
   */
  @StencilEvent({
    bubbles: true,
    cancelable: true,
    composed: true,
  })
  searchSubmitted: EventEmitter<Event>;

  handleOnInput(event: Event) {
    this.inputValue = (event?.target as HTMLInputElement)?.value || '';
  }

  handleSubmit(event: Event) {
    this.searchSubmitted.emit(event);
  }

  handleItemSelected(itemIndex: number) {
    this.searchResultSelected.emit(itemIndex);
    this.inputValue = this.searchResults?.[itemIndex];
    this.showResults = false;
  }

  handleClear() {
    this.inputValue = '';
    this.showResults = false;
  }

  render() {
    return (
      <div
        onFocusin={() => {
          this.showResults = true;
        }}
        onFocusout={() => {
          this.showResults = false;
        }}
      >
        <input type="text" value={this.inputValue} onInput={this.handleOnInput.bind(this)}></input>
        {this.inputValue?.length ? (
          <button id="clearBtn" onClick={this.handleClear.bind(this)}>
            <img src="/Clear.svg"></img>
          </button>
        ) : null}
        {this.showResults && (
          <section>
            {this.highlightedResults?.map((resultItem, index) => {
              return (
                <button class="resultItem" onClick={() => this.handleItemSelected(index)}>
                  <span innerHTML={resultItem}></span>
                </button>
              );
            })}
          </section>
        )}

        <button onClick={this.handleSubmit.bind(this)}>
          <img src={`/Search.svg`}></img>
        </button>
      </div>
    );
  }
}
